import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import TranslatableInput from '../components/inputs/TranslatableInput';
import TranslatableField from '../components/fields/TranslatableField';

export const PriceSegmentList = (props) => (
  <List {...props}>
    <Datagrid>
      <TranslatableField source="title" />
      <EditButton {...props} basePath="/price-segments" />
      <DeleteButton {...props} basePath="/price-segments" />
    </Datagrid>
  </List>
);

// eslint-disable-next-line no-shadow
const PriceSegmentTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

export const PriceSegmentEdit = (props) => (
  <Edit title={<PriceSegmentTitle />} {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TranslatableInput source="title" {...props} />
    </SimpleForm>
  </Edit>
);

export const PriceSegmentCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" />
      <TranslatableInput source="title" {...props} />
    </SimpleForm>
  </Create>
);
